import { createStyles, rem } from '@mantine/core'
import { GLAZING_TEMPLATE_DEFAULT_COLOR } from '@/features/glazing/GlazingTemplate/consts/glazing-template'

export interface StylesParams {
  color: string | null
}

export default createStyles((theme, _params: StylesParams) => {
  const { color } = _params

  const height = rem(32)

  return {
    root: {
      width: '100%',
      height,
      backgroundColor: color || GLAZING_TEMPLATE_DEFAULT_COLOR,
    },
  }
})
